export default "__VITE_ASSET__CwXctCKv__"